import styled from 'styled-components';
import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

    & .ant-layout {
        background: #fff;
    }

    & .ant-layout.site-layout{
        background: #f0f2f5
    }

    & .ant-modal-header{
        border-top-right-radius: ${props=>props.theme.radius}rem;
        border-top-left-radius: ${props=>props.theme.radius}rem;
        color: ${props=>props.theme.palette.text.primary};
    }

    & .ant-modal-content{
        border-radius: ${props=>props.theme.radius}rem;
    }

    // & .ant-modal-close {
    //     transform: translate(8px,-10px);
    //     border-radius: .357rem;
    //     padding: .2rem .62rem;
    //     -webkit-box-shadow: 0 3px 8px 0 rgba(11,10,25,.49)!important;
    //     box-shadow: 0 3px 8px 0 rgba(11,10,25,.49)!important;
    //     background: #fff;
    //     display: flex;
    //     justify-content: center;
    //     flex-direction: row;
    //     font-size: 21px;
    //     transition: all 0.3s;

    //     background-color: ${props=>props.theme.palette.primary.light};
    // }

    // & .ant-modal-close:hover {
    //     transform: translate(8px,-4px);
    // }

    // & .ant-modal-close-x {
    //     display: flex;
    //     padding: 0.2rem 0;
    //     height: auto;
    //     width: auto;
    // }

    // & .ant-modal-header {
    //     background-color: ${props=>props.theme.palette.primary.main};
    // }

    & input.ant-input {
        padding: 0.42rem 0.42rem !important;
        border: 1px solid #E4E6EF !important;
        border-radius: 0.42rem !important;
    }

    & div.ant-select-selector {
        border: 1px solid #E4E6EF !important;
        border-radius: 0.42rem !important;
    }

    & .ant-form-item {
        margin-bottom: 0.75rem;
    }


    & .text-align-left{
        text-align: left;
    }

    & .width-full {
        width: 100%;
    }

    & button.ant-btn {
        border-radius:  ${props=>props.theme.radius}rem;
    }

    & .ant-radio-button-wrapper:first-child {
        border-radius: ${props=>props.theme.radius}rem 0 0 ${props=>props.theme.radius}rem;
    }

    & .ant-radio-button-wrapper:last-child {
        border-radius: 0 ${props=>props.theme.radius}rem ${props=>props.theme.radius}rem 0;
    }

    & .ant-picker{
        border: 1px solid ${props=>props.theme.palette.common.light};
        border-radius:  ${props=>props.theme.radius}rem;
    }

    .ant-form-item-explain.ant-form-item-explain-error , 
    div.warning{
        color: ${props=>props.theme.palette.primary.alert} !important;
    }

`;

export const ConfirmArea = styled.div`
    display: flex;
    justify-content: flex-end;
    padding-top: ${props=>props.theme.rowPadding1}px;
    padding-bottom: ${props=>props.theme.rowPadding1}px;

    & > * {
        margin-left: ${props=>props.theme.rowPadding1}px;
    }

    & > *:first-child{
        margin-left: 0px;
    }
`

export const ActionBarContainer = styled.div`
    display: flex;
    flex: 1;
`

export const PageContent = styled.div`
    background: ${props=>props.theme.componentBackground};
    border-radius: ${props=>props.theme.radius}rem;
    margin-top: ${props=>props.theme.verticalMargin};
`

export const DisInlineFlex = styled.div`
  display: inline-flex;
`

export const AlertMessage = styled.div`
    color: red;
`

export const Block = styled.div`
    padding-bottom: ${props=>props.theme.rowPadding3}px;
`
